import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowLeft,
  faArrowRight,
  faExternalLinkAlt,
  faSearch
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faArrowLeft, faArrowRight, faExternalLinkAlt, faSearch);

Vue.component("vue-fontawesome", FontAwesomeIcon);
